import { all, put, select, takeEvery } from 'redux-saga/effects';
import { NotificationsActions, SearchActions, SettingsActions } from './actions';
import { fetchAttributes, fetchCategories, fetchProjects } from '../../api/settingsApi';
import { NotificationVariants } from './notificationHelpers';

const workerFetchCategories = function* (): Generator<any> {
    try {
        const response = yield fetchCategories();
        yield put({ type: SettingsActions.FETCH_CATEGORIES_SUCCESS, payload: response });
    } catch (error) {
        yield put({ type: SettingsActions.FETCH_CATEGORIES_ERROR, payload: error });
    }
}

const workerFetchAttributes = function* (): Generator<any> {
    try {
        const response = yield fetchAttributes();
        yield put({ type: SettingsActions.FETCH_ATTRIBUTES_SUCCESS, payload: response });
    } catch (error) {
        yield put({ type: SettingsActions.FETCH_ATTRIBUTES_ERROR, payload: error });
        yield put({ type: NotificationsActions.ADD_NOTIFICATION, payload: { title: 'Failed', description: 'Failed to fetch attributes. Please check your connection', variant: NotificationVariants.ERROR } });

    }
}

const workerFetchProjects = function* (): Generator<any> {
    try {
        const projectsTerm = yield select((state: any) => state.settings.projectsTerm);
        const response = yield fetchProjects(projectsTerm);
        yield put({ type: SettingsActions.FETCH_PROJECTS_SUCCESS, payload: response });
    } catch (error) {
        yield put({ type: SettingsActions.FETCH_PROJECTS_ERROR, payload: error });
    }
}

const workerAddProjectTag = function* (action: any): Generator<any> {
    try {
        const term = action.payload;
        if (term.length > 0) {
            yield put({
                type: SearchActions.ADD_TAG, payload:
                {
                    id: term,
                    key: 'project',
                    label: term,
                    type: 'terms'
                }
            });
        }
    } catch (error) {
        yield put({ type: SettingsActions.FETCH_PROJECTS_ERROR, payload: error });
    }
}



export function* watcherSettingsActions() {
    yield all([
        takeEvery(SettingsActions.FETCH_CATEGORIES, workerFetchCategories),
        takeEvery(SettingsActions.FETCH_PROJECTS, workerFetchProjects),
        takeEvery(SettingsActions.FETCH_ATTRIBUTES, workerFetchAttributes),
        takeEvery(SettingsActions.ADD_PROJECT_TAG, workerAddProjectTag),
    ])
}